import "design/introduceCss/way.css";
import { useCallback, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
declare global {
  interface Window {
    google: any;
    initMap: any;
  }
}

const Way = () => {
  const { t } = useTranslation();
  const mapRef = useRef<HTMLDivElement | null>(null);

  const initMap = useCallback(() => {
    if (!window.google || !mapRef.current) return;

    const map = new window.google.maps.Map(mapRef.current, {
      center: { lat: 36.4271206, lng: 127.3947981 },
      zoom: 16,
    });

    new window.google.maps.Marker({
      position: { lat: 36.4271206, lng: 127.3947981 },
      map: map,
      title: "Young-IT",
    });
  }, []);

  useEffect(() => {
    // 이미 Google Maps 로드됨 → 재로드 방지
    if (window.google && window.google.maps) {
      initMap();
      return;
    }

    // 중복 로드 방지
    if (document.getElementById("google-map-script")) {
      return;
    }

    const script = document.createElement("script");
    script.id = "google-map-script";
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCsSjCLsEDkL6jVuqT1fyHkxfdIV-i9mgI`; // ← 여기에 실제 API 키 넣기
    script.async = true;

    script.onload = initMap; // 로드 후 실행
    document.body.appendChild(script);
  }, [initMap]);

  return (
    <div className={"way-container"}>
      <div className={"way-title"}>
        <h1>{t("menu.way")}</h1>
      </div>
      <div className={"way-content"}>
        <div className="map google-map" ref={mapRef}></div>
        <div className={"way-content-text"}>
          <div className={"title"}>
            <p>{t("way.address")}</p>
            <span>{t("overview.address")}</span>
          </div>
          <div className={"description"}>
            <span>{t("way.transportation")}</span>
            <div className={"description-content"}>
              <p>{t("way.sintanjin")}</p>
              <p>{t("way.northDaejeon")}</p>
              <p>{t("way.yuseong")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Way;
